import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Menu, Header } from 'semantic-ui-react';

import Preview from './Components/Preview';

import './App.css';

const Home = () => {
  return (
    <div className='centering-container'>
      <Header>Invalid resource</Header>
    </div>
  );
};

class App extends Component {
  render() {
    return (
      <div>
        <Menu fixed='top'>
          <Menu.Item>
            Richie Ads Preview
          </Menu.Item>
        </Menu>
        <div>
          <Switch>
            <Route exact path='/:uuid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/content/index.html' component={Preview}/>
            <Route exact path='/:uuid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/:pageNumber(\d+)?' component={Preview}/>
            <Route component={Home}/>
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;
